import type { PayPointBaseDto } from "Infrastructure/Api/Api";

export const activeFirstSort = (
  a: PayPointBaseDto,
  b: PayPointBaseDto,
): number => {
  const aHasCard = !!a.nfcCardNo;
  const bHasCard = !!b.nfcCardNo;
  return aHasCard === bHasCard ? 0 : aHasCard ? -1 : 1;
};

export const activePaypointsFilter = ({ nfcCardNo }: PayPointBaseDto) =>
  !!nfcCardNo;
